import React from 'react'
import {Checkbox as CheckboxUI, FormControlLabel, Tooltip} from '@material-ui/core';
import getObjectValue from 'libs/getObjectValue'
import Tr from 'translations/Translations';

function Checkbox(
    {
        formikProps,
        id,
        htmlId,
        label,
        disabled,
        checkboxClassName,
        fullWidth,
        checked,
        className,
        labelClassName,
        labelPlacement,
        onChange = () => {
        },
    }) {

    const value = checked === undefined ? getObjectValue(id, formikProps.values, false) : checked

    const checkbox = <Tooltip title={value ? Tr('checkbox_uncheck') : Tr('checkbox_check')}>
        <CheckboxUI
            color='primary'
            name={id}
            checked={value}
            onChange={(event) => {
                if (formikProps) formikProps.handleChange(event);
                onChange(event);
            }}
            onBlur={formikProps ? formikProps.handleBlur : undefined}
            disabled={disabled}
            className={checkboxClassName}
            id={htmlId}
        />
    </Tooltip>

    if (Boolean(label)) {
        return (
            <FormControlLabel
                className={className}
                style={fullWidth ? { width: '100%' } : undefined}
                control={checkbox}
                label={label}
                classes={{
                    label: labelClassName
                }}
                labelPlacement={labelPlacement}
            />
        )
    }
    return checkbox;
}

export default Checkbox
